import React, { useEffect } from 'react';
import { arrayOf, bool, func, object } from 'prop-types';
import { useDispatch } from 'react-redux';

import BatchProgressDialog from './BatchProgressDialog';
import { deleteRule, fetchRuleKPIs } from '../../actions/ruleActions';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';
import useQueue from '../../hooks/useQueue';

const RuleDeleteSelectedModal = ({ onClose, open, rules }) => {
    const dispatch = useDispatch();
    const [queue, runQueue] = useQueue(async (rule, { fulfill, reject}) => {
        try {
            const updatedRule = await dispatch(deleteRule(rule));
            fulfill({
                item:  rule,
                value: updatedRule
            });
            await dispatch(fetchRuleKPIs());
        } catch (error) {
            reject({
                error,
                item: rule
            });
        }
    });

    useEffect(() => {
        if (!open) {
            return;
        }
        runQueue(rules);
    }, [open]);

    useEffect(() => {
        if (queue.complete && queue.successful) {
            dispatch(
                enqueueSnackbar('Rule(s) deleted successfully!', 'success')
            );
            onClose();
        }
    }, [queue.complete, queue.successful]);

    return (
        <BatchProgressDialog
            {...queue}
            onClose={onClose}
            open={open}
            title="Deleting Selected Rules"
        />
    );
};

RuleDeleteSelectedModal.defaultProps = {
    onClose: () => {},
    open:    false,
    rules:   []
};

RuleDeleteSelectedModal.propTypes = {
    onClose: func,
    open:    bool,
    rules:   arrayOf(object)
};

export default RuleDeleteSelectedModal;
